import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../_metronic/_partials/controls";
import BootstrapTable from "react-bootstrap-table-next";
import {
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  headerSortingClasses,
} from "../../_metronic/_helpers";
import { useSubheader } from "../../_metronic/layout";
import { Link, useHistory } from "react-router-dom";
import { baseURLV1, privilegeURLV2 } from "../service/API.js";
import moment from "moment";
import Swal from "sweetalert2";
import axios from "axios";
import paginationFactory from "react-bootstrap-table2-paginator";
import Pagination2 from "@material-ui/lab/Pagination";
import { useSelector } from "react-redux";
import * as loadingData from "./loading.json";
import * as successData from "./success.json";
import FadeIn from "react-fade-in";
import Lottie from "react-lottie";

export const SpecialCampaign = () => {
  const suhbeader = useSubheader();
  const allData = [];
  const [lisData, setListData] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalSize, setTotalSize] = useState(100);
  const [openImage, setOpenImage] = useState(false)
  const [imgSelect, setImgSelect] = useState('')
  const [rotation, setRotation] = useState(0)
  const [id, setId] = useState('')
  const [relate_product_check, setRelateProductCheck] = useState(false)
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  suhbeader.setTitle("Special Campaign Management");
  const { authToken, accessTokenPrivilege } = useSelector((state) => state.auth);
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: loadingData.default,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };

  const defaultOptions2 = {
    loop: true,
    autoplay: true,
    animationData: successData.default,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };
  const history = useHistory();
  useEffect(() => {
    getListPrivilege()

  }, []);

  const getData = async (page, limit, search) => {
    setPage(page);
    await axios({
      method: "get",
      url: `${baseURLV1}/specialCampaign?page=${page}&limit=${limit}${search !== undefined && search !== "" ? "&search=" + search : ""
        }`,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    }).then((res) => {
      var totalpage = Math.ceil(res.data.total / res.data.limit);
      setTotalPage(totalpage);
      setTotalSize(res.data.total);
      setLimit(res.data.limit);
      setListData(res.data.data);
      setLoading(false)
      setSuccess(true)
      // console.log(res.data.data)
    });
  };

  const convertDate = (date, formatDate) => {
    const dates = new Date(date)
    const result = dates.toLocaleDateString(formatDate, {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    })

    return result
  }

  const mapPrivilege = (id) => {
    console.log('listPrivilege', listPrivilege)
    const temp = listPrivilege.filter(item => id == item.id)
    console.log('check', temp, temp[0].point)

    return temp
  }

  const getListPrivilege = async () => {
    await axios({
      method: "get",
      url: `${privilegeURLV2}/deal?page=1&limit=1000&campaign_id=22`,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${accessTokenPrivilege}`,
      },
    }).then(async (res) => {
      setListPrivilege(res.data.data)
      await getData(1, 10, search);
      console.log(res.data.data.filter(item => item.id == 2886))
    }).catch((err) => {
      //window.location.assign("/logout");
    });
  };
  const [listPrivilege, setListPrivilege] = useState([]);
  const [privilege, setPrivilege] = useState(0);
  const [privilegePoint, setPrivilegePoint] = useState(0);
  const [reducePoint, setReducePoint] = useState(0);

  const handlePrivilegePoint = async (id, list = listPrivilege, type = 'onChange') => {
    setPrivilege(id)
    if (type == 'onChange') {
      setReducePoint(0)
    }
    let result = await list.find(item => item.id == id)
    console.log(result);
    if (result) {
      await setPrivilegePoint(result.point)
    }
  }
  const columns = [
    {
      dataField: "title_th",
      text: "ชื่อแคมเปญพิเศษ",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div style={{ width: '120px' }}>
            <p>{row.title_th}</p>
          </div>
        );
      },
    },
    {
      dataField: "description_th",
      text: "รายละเอียด",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div style={{ width: '120px' }}>
            <p>{row.description_th}</p>
          </div>
        );
      },
    },
    {
      dataField: "campaign_type",
      text: "ประเภทแคมเปญ",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div style={{ width: '150px' }}>
            <p>{row.campaign_type ? row.campaign_type : '-'}</p>
          </div>
        );
      },
    },
    {
      dataField: "plus_point",
      text: "จำนวนคะแนนที่ปรับเพิ่ม",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div style={{ width: '170px' }}>
            <p>{row.plus_point ? row.plus_point : '-'}</p>
          </div>
        );
      },
    },
    {
      dataField: "multiple_point",
      text: "จำนวนคะแนนที่คูณเพิ่ม",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div style={{ width: '170px' }}>
            <p>{row.multiple_point ? row.multiple_point : '-'}</p>
          </div>
        );
      },
    },
    {
      dataField: "plus_point",
      text: "จำนวนคะแนนปกติ",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div style={{ width: '160px' }}>
            <p>{row.type == 'Burn' ? mapPrivilege(row.privilege_id)[0].point : '-'}</p>
          </div>
        );
      },
    },
    {
      dataField: "reduce_point",
      text: "จำนวนคะแนนที่ปรับลด",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div style={{ width: '180px' }}>
            <p>{row.type == 'Burn' ? row.reduce_point : '-'}</p>
          </div>
        );
      },
    },
    {
      dataField: "plus_point",
      text: "จำนวนคะแนนหลังปรับลด",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div style={{ width: '200px' }}>
            <p>{row.type == 'Burn' ? mapPrivilege(row.privilege_id)[0].point - row.reduce_point : '-'}</p>
          </div>
        );
      },
    },
    {
      dataField: "start_date",
      text: "วันที่เริ่มแคมเปญ",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div style={{ width: '140px' }}>
            <p>{row.start_date ? convertDate(row.start_date, 'th-TH') : '-'}</p>
          </div>
        );
      },
    },
    {
      dataField: "end_date",
      text: "วันที่สิ้นสุดแคมเปญ",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div style={{ width: '140px' }}>
            <p>{row.end_date ? convertDate(row.end_date, 'th-TH') : '-'}</p>
          </div>
        );
      },
    },
    {
      text: "Action",
      dataField: "id",
      formatter: (id, row, rowIndex) => {
        return (
          <div style={{ width: '150px' }}>
            <button
              type="button"
              className="btn btn-primary mr-2"
              onClick={() => editItem({ id, row, rowIndex })}
            >
              Edit
            </button>

            <button
              type="button"
              className="btn btn-primary"
              onClick={() => deleteItem({ row, rowIndex })}
            >
              Delete
            </button>

          </div>
        );
      },
    },
  ];

  const rotate = () => {
    let newRotation = Number(rotation) + 90
    if (newRotation >= 360) {
      newRotation = -360
    }
    setRotation(newRotation)
  }


  const editItem = (data) => {
    history.push("/EditSpecialCampaign", data);
  };

  const deleteItem = (data) => {
    console.log(data)
    Swal.fire({
      title: "ยืนยันการลบรายการ?",
      text: "รายการนี้จะถูกลบออก !",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "ลบ!",
      cancelButtonText: "ไม่ลบ",
    }).then((result) => {
      if (result.value) {
        axios
          .delete(`${baseURLV1}/specialCampaign/${data.row.id}`)
          .then((res) => {
            Swal.fire("ทำรายการสำเร็จ!", "", "success");
            getData(1, limit, search);
          })
          .catch((err) => {
            Swal.fire(
              "ทำรายการไม่สำเร็จ!",
              "",
              "error"
            );
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("ยกเลิกการทำรายการ", "", "error");
      }
    });
  };
  const [search, setSearch] = useState();
  const handleSearch = () => {
    setPage(1);
    getData(1, limit, search);
  };

  const handlePageChange = (event, value) => {
    setPage(value);
    getData(value, limit, search);
  };

  const handlePageSizeChange = (event) => {
    setLimit(event.target.value);
    getData(1, event.target.value, search);
  };

  const handleClose = () => {
    setId('')
    setOpenImage(false)
    setImgSelect('')
    setRelateProductCheck(false)
  }

  return (
    <Card>
      <CardHeader title="Special Campaign Menu">
        <CardHeaderToolbar>
          <Link to="/CreateSpecialCampaign">
            <button type="button" className="btn btn-primary">
              + Create
            </button>
          </Link>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        {/* <div className="row form-inline mb-2">
          <div className="col-lg-4 col-md-4 col-sm-4">
            <div className="form-group">
              <input
                type="text"
                className="form-control"
                placeholder="Text Search"
                style={{ width: "100%" }}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>
          <div className="col-lg-2 col-md-2 col-sm-2">
            <div className="form-group">
              <button
                type="button"
                id="button"
                className="btn btn-primary"
                style={{ width: "100%" }}
                onClick={() => handleSearch()}
              >
                Search
              </button>
            </div>
          </div>
        </div> */}
        <div className="row form-inline mb-2">
          <div className="col-lg-4 col-md-4 col-sm-4">
            <div className="form-group">
              <input
                type="text"
                className="form-control"
                placeholder="Text Search"
                style={{ width: "100%" }}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>
          <div className="col-lg-2 col-md-2 col-sm-2">
            <div className="form-group">
              <button
                type="button"
                id="button"
                className="btn btn-primary"
                style={{ width: "100%" }}
                onClick={() => handleSearch()}
              >
                Search
              </button>
            </div>
          </div>
        </div>
        {!success ? (
          <FadeIn>
            <div style={{ display: "flex" }}>
              {loading ? (
                <div className="row">
                  <div style={{
                    position: "fixed", top: "50%", left: "60%", transform: "translate(-50%, -50%)"
                  }}>

                    <div className="spinner-grow text-primary spinner-grow-sm" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                    <div className="spinner-grow text-secondary spinner-grow-sm" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                    <div className="spinner-grow text-success spinner-grow-sm" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                    <div className="spinner-grow text-danger spinner-grow-sm" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                    <div className="spinner-grow text-warning spinner-grow-sm" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                    <div className="spinner-grow text-info spinner-grow-sm" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                    <div className="spinner-grow text-light spinner-grow-sm" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                    <div className="spinner-grow text-dark spinner-grow-sm" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                </div>
              ) : (
                <Lottie options={defaultOptions2} height={140} width={140} />
              )}
            </div>
          </FadeIn>
        ) : (
          <BootstrapTable
            keyField="id"
            data={lisData}
            columns={columns}
            wrapperClasses="table-responsive table-cm"
            bordered={false}
            classes="header-table table table-head-custom table-vertical-center overflow-hidden table-fixed"
            bootstrap4
          />
        )}

        <div className=" col-lg-12">
          <div className="row">
            <div className="col-lg-6">
              <div className="mt-3">
                {"Items per Page: "}
                <select onChange={handlePageSizeChange} value={limit}>
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
                {`  Result : ${totalSize} records`}
              </div>
            </div>
            <div className="col-lg-6">
              <Pagination2
                className="mt-3 "
                count={totalPage}
                page={page}
                siblingCount={1}
                boundaryCount={1}
                variant="outlined"
                shape="rounded"
                onChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};
